import { useDispatch } from 'react-redux';
import { FormControlLabel } from '@material-ui/core';
import I18n from 'i18n-js';
import { bool } from 'prop-types';

import {
  setNotificationsDisabled,
  setNotificationsEnabled,
} from '@lootboy/lib/actions/DailyBoostActions';

import IOSSwitch from '~/components/IOSSwitch';

import styles from './NotificationsSwitch.module.scss';

export default function NotificationsSwitch({ dailyNotificationsEnabled }) {
  const dispatch = useDispatch();

  return (
    <div className={styles.dailyBoostNotifications}>
      <FormControlLabel
        control={
          <IOSSwitch
            checked={dailyNotificationsEnabled}
            onChange={({ target: { checked } }) =>
              dispatch(
                (checked
                  ? setNotificationsEnabled
                  : setNotificationsDisabled)(),
              )
            }
            color="default"
          />
        }
        classes={{
          root: styles.dailyBoostLabel,
          labelPlacementStart: styles.labelPlacementStart,
        }}
        label={I18n.t('DailyView_notification_toggle')}
        labelPlacement="start"
      />
    </div>
  );
}

NotificationsSwitch.propTypes = {
  dailyNotificationsEnabled: bool.isRequired,
};
